import React, { useEffect, useMemo } from "react";
import Form, { FormField } from "../ui/Form";
import * as authAdminActions from "src/redux/slices/authAdminSlice";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { toast } from "react-toastify";

interface ProfileFormAdminProps {
  handleCancel: () => void;
}

const ProfileFormAdmin: React.FC<ProfileFormAdminProps> = ({
  handleCancel,
}) => {
  const dispatch = useAppDispatch();
  const {
    user: { data: user },
    editUser,
  } = useAppSelector((state) => state.authAdmin);

  // ✅ Success/Error side-effects
  useEffect(() => {
    if (editUser.data) {
      toast.success("User Details modified successfully");
      dispatch(authAdminActions.getUserDetailsRequest());
      dispatch(authAdminActions.resetEditUser());
      // handleClose();
    } else if (editUser.error) {
      toast.error(`Error: ${editUser.error}`);
    }
  }, [editUser]);

  // ✅ Define all form fields
  const fields: FormField[] = [
    {
      label: "First Name",
      name: "firstName",
      type: "text",
      placeholder: "Enter first name",
      validations: { required: true },
    },
    {
      label: "Last Name",
      name: "lastName",
      type: "text",
      placeholder: "Enter last name",
      validations: { required: true },
    },
    {
      label: "Email",
      name: "email",
      type: "text",
      placeholder: "Enter email address",
      validations: {
        required: true,
        regex: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
        message: "Invalid email format",
      },
    },
  ];

  const initialState = useMemo(
    () => ({
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
    }),
    [user]
  );

  const handleSubmit = (
    data: { firstName: string; lastName: string; email: string } | any
  ) => {
    try {
      const payload = {
        ...data,
      };
      dispatch(authAdminActions.editUserRequest(payload));
    } catch (error: any) {
      toast.error("Failed to update profile");
      console.error(error);
    }
  };

  return (
    <Form
      initialState={initialState as any}
      fields={fields}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      loading={editUser.loading}
    />
  );
};

export default ProfileFormAdmin;
